import { render } from "./AttackArmoryView.vue?vue&type=template&id=67690416&scoped=true"
import script from "./AttackArmoryView.vue?vue&type=script&lang=js"
export * from "./AttackArmoryView.vue?vue&type=script&lang=js"

import "./AttackArmoryView.vue?vue&type=style&index=0&id=67690416&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-67690416"]])

export default __exports__